module.exports = __webpack_public_path__ + "static/media/logos.7a7061d7.png";